function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useObserverNodeSize } from "../../hooks/useObserverNodeSize";
import { NodesUtil } from "../NodesUtil";
import { useSignal } from "@preact/signals-react";
import { useSize } from "ahooks";
import cls from "classnames";
import { isEmpty } from "lodash";
import React, { useEffect, useRef } from "react";
import { useStore } from "reactflow";
import { ChatContent } from "./ChatContent";
import { ChatInput } from "./ChatInput";
import styles from "./ChatInterface.module.scss";
import { ChatInterfaceBloc } from "./ChatInterfaceBloc";
import { ChatLoading } from "./ChatLoading";
import { ChatMessageLoading } from "./ChatMessageLoading";
import { useEnableScroll } from "../../hooks/useEnableScroll";
export function ChatInterface(props) {
  var _props$checkNodeArr, _props$textAreaValue, _props$textAreaValue2, _props$textAreaValue3, _props$textAreaValue5;
  var bloc = new ChatInterfaceBloc();
  var id = props.id,
    xPos = props.xPos,
    yPos = props.yPos,
    isInCanvas = props.isInCanvas;
  var contentRef = useRef(null);
  var triggerNodeChanges = useStore(function (state) {
    return state.triggerNodeChanges;
  });
  var _useEnableScroll = useEnableScroll(),
    enableScroll = _useEnableScroll.enableScroll,
    mouseEnterLeave = _useEnableScroll.mouseEnterLeave;
  var containerRef = useRef(null);
  var inputRef = useRef(null);
  var isInput = useSignal(false);
  var noWheelClassName = enableScroll && (props.isLongPress || (_props$checkNodeArr = props.checkNodeArr) !== null && _props$checkNodeArr !== void 0 && _props$checkNodeArr.includes(id) || isInput.value) ? NodesUtil.constants.NO_WHEEL : "";
  var containerClassName = cls(styles.container, noWheelClassName);
  var containerHeightRef = useRef(0);
  var containerWidthRef = useRef(0);
  var inputHeightRef = useRef(0);
  var conatinerSize = useSize(containerRef);
  var _useObserverNodeSize = useObserverNodeSize(inputRef),
    height = _useObserverNodeSize.size.height;
  function refreshNodeData() {
    props.onChange(_objectSpread(_objectSpread({}, props.textAreaValue), {}, {
      chatList: bloc.chatList.value,
      preQuery: bloc.prevInput.value,
      chatHistory: bloc.chatHistoryVarible.value,
      isStreamStopped: bloc.isStreamStopped.value
    }));
  }
  useEffect(function () {
    refreshNodeData();
  }, [bloc.chatList.value, bloc.isStreamStopped.value]);
  function scrollToBottom() {
    if (!contentRef.current) {
      return;
    }
    contentRef.current.scrollTop = contentRef.current.scrollHeight - contentRef.current.clientHeight;
  }
  function _onStreamingContentStopped(chatList) {
    bloc.isStreamStopped.value = true;
    if (!isEmpty(chatList)) {
      bloc.chatList.value = chatList;
    }
    scrollToBottom();
  }
  useEffect(function () {
    // sync states between canvas and preview
    if (!props.isShare) {
      bloc.init(props, props.isShare, isInput.value);
    }
  }, [(_props$textAreaValue = props.textAreaValue) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue.chatList) === null || _props$textAreaValue === void 0 ? void 0 : _props$textAreaValue.length, // 这里不能使用props.textAreaValue.chatList，会造成一直循环渲染
  (_props$textAreaValue2 = props.textAreaValue) === null || _props$textAreaValue2 === void 0 ? void 0 : _props$textAreaValue2.isStreamStopped]);
  useEffect(function () {
    bloc.init(props, props.isShare, isInput.value);
  }, [(_props$textAreaValue3 = props.textAreaValue) === null || _props$textAreaValue3 === void 0 ? void 0 : _props$textAreaValue3.date]);
  useEffect(function () {
    if (!conatinerSize) {
      return;
    }
    containerHeightRef.current = conatinerSize.height + 20;
    containerWidthRef.current = conatinerSize.width + 20;
    // if (bloc.isStreamStopped.value) {
    //   refreshNodeData();
    // }
  }, [conatinerSize]);
  useEffect(function () {
    if (!conatinerSize) {
      return;
    }
    if (inputHeightRef.current === 0) {
      inputHeightRef.current = height;
    }
    var delta = height - inputHeightRef.current; /// 和上一次 input 的差
    var newYPef = yPos - delta / 2;
    var newHRef = containerHeightRef.current + delta;

    /// 高度变化 chat 内容更新时触发，历史数据不要触发
    if (delta > 0 && !isNaN(xPos) && !isNaN(newYPef)) {
      triggerNodeChanges([{
        id: id,
        type: "position",
        position: {
          x: xPos,
          y: newYPef
        }
      }, {
        id: id,
        type: "dimensions",
        updateStyle: true,
        resizing: true,
        dimensions: {
          width: containerWidthRef.current,
          height: newHRef
        }
      }]);
    }
    inputHeightRef.current = height;
  }, [height]);
  useEffect(function () {
    var _props$textAreaValue4;
    if ((_props$textAreaValue4 = props.textAreaValue) !== null && _props$textAreaValue4 !== void 0 && _props$textAreaValue4.pubsub_topic) {
      bloc.listenTopic();
    }
  }, [(_props$textAreaValue5 = props.textAreaValue) === null || _props$textAreaValue5 === void 0 ? void 0 : _props$textAreaValue5.pubsub_topic]);
  return bloc.isLoading.value ? /*#__PURE__*/React.createElement("div", {
    className: containerClassName,
    ref: containerRef
  }, /*#__PURE__*/React.createElement(ChatLoading, null), /*#__PURE__*/React.createElement("div", {
    className: styles.chatInptContainer
  }, /*#__PURE__*/React.createElement(ChatInput, {
    inputText: bloc.inputText,
    isLoading: bloc.isMessageLoading.value,
    isInCanvas: isInCanvas
  }))) : /*#__PURE__*/React.createElement("div", {
    className: containerClassName,
    ref: containerRef,
    onMouseEnter: function onMouseEnter() {
      return mouseEnterLeave(true);
    },
    onMouseLeave: function onMouseLeave() {
      return mouseEnterLeave(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.chatContent,
    ref: contentRef
  }, /*#__PURE__*/React.createElement(ChatContent, {
    isShare: props.isShare,
    onLinkClicked: function onLinkClicked() {
      return bloc.onLinkClicked();
    },
    chatList: bloc.chatList.value,
    isStreamStopped: bloc.isStreamStopped.value,
    textAreaValueChatList: bloc.textAreaValueChatList.value,
    AssistantDefaultList: bloc.AssistantDefaultList.value,
    onRegenerateClicked: function onRegenerateClicked() {
      return bloc.onRegenerate();
    },
    onRefreshHeight: function onRefreshHeight() {
      return scrollToBottom();
    },
    onStreamingContentStopped: function onStreamingContentStopped(chatList) {
      return _onStreamingContentStopped(chatList);
    }
  })), bloc.isMessageLoading.value && /*#__PURE__*/React.createElement("div", {
    className: styles.chatMessageLoading
  }, /*#__PURE__*/React.createElement(ChatMessageLoading, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.chatInptContainer,
    ref: inputRef
  }, /*#__PURE__*/React.createElement(ChatInput, {
    inputText: bloc.inputText,
    isInput: isInput,
    isLoading: bloc.isMessageLoading.value,
    isInCanvas: isInCanvas,
    onSendCliked: function onSendCliked() {
      return bloc.onPressEnter();
    },
    onFocusInput: function onFocusInput() {
      var _props$focusNodeTopBa;
      props === null || props === void 0 || (_props$focusNodeTopBa = props.focusNodeTopBarById) === null || _props$focusNodeTopBa === void 0 || _props$focusNodeTopBa.call(props, id);
    }
  })));
}